export const VideoPortfolio = () => {
  return (
    <div className="max-w-[1064px] mx-auto py-[40px] lg:py-[80px]">
      <h1 className="text-[30px] lg:text-[50px] text-center font-bold">
        View Our Recruitment Video Portfolio
      </h1>
      <div>
        <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
          <iframe
            src="https://vimeo.com/showcase/11813157/embed"
            title="showcase"
            allowfullscreen
            frameborder="0"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
            }}
          ></iframe>
        </div>
      </div>
    </div>
  );
};
